// Service pour gérer les alertes système via popups
// Note: Ce service est maintenant intégré avec le système de popup existant

// Service pour gérer les alertes système (erreurs, warnings, etc.)
export class AlertService {
  
  // Types d'alertes système
  static ALERT_TYPES = {
    ERROR: 'error',
    WARNING: 'warning',
    SECURITY: 'security',
    SYSTEM: 'system',
    INFO: 'info'
  };
  
  // Niveaux de priorité
  static PRIORITY_LEVELS = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    CRITICAL: 'critical'
  };
  
  // Instance du système de notification popup (sera injectée)
  static notificationSystem = null;
  
  // Méthode pour injecter le système de notification
  static setNotificationSystem(notificationSystem) {
    this.notificationSystem = notificationSystem;
  }
  
  // Méthode interne pour afficher une alerte popup
  static showAlert(type, message, priority = 'medium') {
    if (!this.notificationSystem) {
      console.error('Système de notification non initialisé');
      return;
    }
    
    // Convertir le type d'alerte en type de notification popup
    let notificationType = 'error'; // par défaut
    switch (type) {
      case 'error':
        notificationType = 'error';
        break;
      case 'warning':
        notificationType = 'warning';
        break;
      case 'security':
        notificationType = 'error';
        break;
      case 'system':
        notificationType = 'info';
        break;
      default:
        notificationType = 'info';
    }
    
    // Afficher la popup avec une durée plus longue pour les alertes critiques
    const duration = priority === 'critical' ? 10000 : priority === 'high' ? 7000 : 5000;
    
    this.notificationSystem(notificationType, message, {
      autoClose: true,
      duration: duration
    });
  }
  
  // Créer une nouvelle alerte (maintenant affiche une popup)
  static createAlert(userId, type, title, message, priority = 'medium', data = {}) {
    this.showAlert(type, message, priority);
    return Promise.resolve({ success: true });
  }
  
  // Toutes les méthodes Firebase ont été supprimées - les alertes sont maintenant des popups
  
  // Alertes spécifiques pour les erreurs système
  
  // Alerte générale d'erreur de paiement
  static alertPaymentError(userId, errorType, description) {
    this.showAlert(
      this.ALERT_TYPES.ERROR,
      description || 'Erreur lors du traitement du paiement',
      this.PRIORITY_LEVELS.HIGH
    );
    return Promise.resolve({ success: true });
  }
}

export default AlertService;